export const METAL_NAMES: {[key:string] : any } = {
    AU : {name: 'Oro'},
    AG : {name: 'Plata'},
    PT : {name: 'Platino'},
    PD : {name: 'Paladio'},
    RH : {name: 'Rodio'},    
  }